const errors = (state=null, action) => {
    switch(action.type){
        case 'SET_ERRORS' :
            return action.value;
        default:
            return state;
    }
};


const notices = (state=[], action) => {
    switch(action.type){
        case 'ADD_NOTICE':
            if( state.find(val => val.notice_type == action.notice_type) ){
                return state
            }
            return [
                ...state,
                {
                    notice_type: action.notice_type,
                    message: action.message
                }
            ];
        case 'REMOVE_NOTICE':
            const newState = state.filter(val => val.notice_type != action.notice_type)
            return newState;
        case 'SUCCESS_NOTICE':
            return [{notice_type: 'success', message: action.value}];
        case 'CLEAR_NOTICES':
            return [];
        default:
            return state;
    }
};

export  {errors, notices};